import React, { useEffect, useState } from "react";
import ContentHeader from "../../common/ContentHeader";
import EventTable from "./EventTable";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { clearCurrentEvent } from "../../../store/actions/currentEvent";
import { clearCurrentRescource } from "../../../store/actions/currentArticle";
import {
  deleteEvent,
  getEventsData,
  toggleEventActivation,
} from "../../../store/actions/event";
import {
  filterTableRows,
  getStatusClass,
  getUpdatedDate,
} from "../../common/GeneralHelper";
import { setFilteredEventQueryParams } from "../../../store/actions/filter";
import {
  CONTENT_STATES,
  DEFAULT_PAGE_SIZE,
} from "../../../constants/GeneralConstant";
import ServerSideTable from "./EventTable";
import { formatDate } from "../../common/DateFormatter";
import { Tooltip } from "@mui/material";

import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import FileOpenOutlinedIcon from "@mui/icons-material/FileOpenOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import DeleteConfirmationDialog from "../../common/DeleteConfirmationDialog";
import { toast } from "react-toastify";

const EventListing = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [rows, setRows] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const [listData, setListData] = useState([]);
  const [sortModel, setSortModel] = useState([]);

  const { meta, result } = useSelector((state) => state.events.events);

  const { eventParams: filterParams } = useSelector((state) => state.filter);

  const dispatch = useDispatch();
  const { id } = useParams();
  useEffect(() => {
    window.scrollTo(0, 0);
    if (id === undefined) {
      dispatch(clearCurrentEvent());
      dispatch(clearCurrentRescource());
    }
  }, [dispatch, id]);

  const fetchData = async () => {
    try {
      setLoading(true);
      let payload = {
        ...filterParams,
        searchText: searchQuery,
        page: page ? page : 1,
        perPage: pageSize,
        status: [],
      };
      delete payload.search;
      dispatch(getEventsData(payload));
      dispatch(setFilteredEventQueryParams(payload));
    } catch (error) {
      setRows([]); // Reset rows on error
      setRowCount(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, pageSize, sortModel, searchQuery]);

  useEffect(() => {
    setRows(result || []); // Ensure rows is always an array
    setRowCount(meta?.total || 0); // Ensure totalCount is always a number
    setListData(result);
  }, [result]);

  const handleSearchQueryChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleClearSearchQuery = (event) => {
    setSearchQuery("");
  };

  const filteredData = filterTableRows(result, searchQuery);

  const onPageChange = (newPage) => {
    let filters = { ...filterParams, page: newPage + 1 };
    dispatch(setFilteredEventQueryParams(filters));
    setPage(newPage + 1);
  };

  const onPageSizeChange = (newPageSize) => {
    let filters = { ...filterParams, limit: newPageSize };
    dispatch(setFilteredEventQueryParams(filters));
    setPageSize(newPageSize);
  };
  const onSortModelChange = (newSortModel) => setSortModel(newSortModel);

  const getCategoriesLabel = (categories) => {
    let data = categories
      .map((m) => m.title["EN"] || m.title["LU"] || m.title["RY"])
      .join();
    return data;
  };

  const getUpdatedDate = (item) => {
    return item.updatedAt
      ? `${formatDate(item.updatedAt).date} | ${
          formatDate(item.updatedAt).time
        } by ${
          item.updatedBy && item.updatedBy.fullname
            ? item.updatedBy.fullname
            : "Admin"
        }`
      : `${formatDate(item.createdAt).date} | ${
          formatDate(item.createdAt).time
        } by ${
          item.updatedBy && item.updatedBy.fullname
            ? item.updatedBy.fullname
            : "Admin"
        }`;
  };

  const columns = [
    {
      field: "title",
      headerName: "Title",
      width: 150,
      renderCell: (params) =>
        params.value["EN"] || params.value["LU"] || params.value["RY"],
    },
    {
      field: "categories",
      headerName: "Category",
      flex: 1,
      renderCell: (params) => getCategoriesLabel(params.value),
    },

    {
      field: "status",
      headerName: "Status",
      flex: 0.6,
      renderCell: (params) => {
        return (
          <div className={getStatusClass(params.row.status)}>
            {params.row.status}
          </div>
        );
      },
    },
    {
      field: "updatedAt",
      headerName: "Last Updated",
      flex: 1,
      renderCell: (params) => {
        return getUpdatedDate(params.row);
      },
    },
    {
      field: "action",
      headerName: "Action",
      sortable: false,
      flex: 1,
      renderCell: (params) => {
        params.sortDirection && (
          <span>{params.sortDirection === "asc" ? "▲" : "▼"}</span>
        );
        const HandleActivation = (params) => {
          const res = listData?.find((obj) => {
            return obj.id === params.id;
          });

          dispatch(toggleEventActivation(params.id, res))
            .then(() => {
              if (res.status === CONTENT_STATES.PUBLISHED) {
                toast.success("Successfully deactivated!");
              } else {
                toast.success("Successfully activated!");
              }
            })
            .catch((err) => {
              toast.error("Failed to activate/deactivate resource!");
            })
            .finally(() => {
              let payload = { ...filterParams };
              delete payload.type;
              dispatch(getEventsData(payload));
            });
        };
        const faq = listData?.find((obj) => obj.id === params.id);

        let activation;
        if (faq && faq.status === CONTENT_STATES.PUBLISHED) {
          activation = (
            <Tooltip title="deactivate">
              <VisibilityOutlinedIcon
                onClick={() => HandleActivation(params)}
              />
            </Tooltip>
          );
        } else {
          activation = (
            <Tooltip title="activate">
              <VisibilityOffOutlinedIcon
                onClick={() => HandleActivation(params)}
              />
            </Tooltip>
          );
        }
        const [open, setOpen] = useState(false);

        const handleDelete = (params) => {
          dispatch(deleteEvent(params.id))
            .then(() => {
              // Refresh the article list
              let payload = { ...filterParams };
              payload?.type && delete payload.type;
              dispatch(getEventsData(payload)).then(() => {
                toast.success("Successfully deleted!");
              });
            })
            .catch((error) => {
              toast.error("Failed to delete resource!");
            });
        };

        return (
          <>
            <Tooltip title="Edit">
              <FileOpenOutlinedIcon
                onClick={() => {
                  navigate(`/events/${params.id}/edit`);
                }}
              />
            </Tooltip>
            {activation}
            <Tooltip title="Delete">
              <DeleteOutlineOutlinedIcon onClick={() => setOpen(true)} />
            </Tooltip>
            <DeleteConfirmationDialog
              open={open}
              onClose={() => setOpen(false)}
              onDelete={() => handleDelete(params)}
            />
          </>
        );
      },
    },
  ];

  return (
    <>
      <ContentHeader
        header="Events"
        route="/new-events"
        searchQuery={searchQuery}
        onSearchQueryChange={handleSearchQueryChange}
        onClearSearchQuery={handleClearSearchQuery}
        searchPlaceholder="Search by Title, Category"
        isNearBy={false}
        count={meta?.total ?? 0}
      />
      <ServerSideTable
        searchQuery={searchQuery}
        columns={columns}
        rows={rows}
        rowCount={rowCount}
        loading={loading}
        page={page}
        pageSize={pageSize}
        listData={listData}
        setSortModel={setSortModel}
        filterParams={filterParams}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
        onSortModelChange={onSortModelChange}
        fetchData={fetchData}
        sortModel={sortModel}
      />
    </>
  );
};

export default EventListing;
